import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";

export default function ModuleWrapper({ roleComponents }) {
  const { user } = useContext(AuthContext);

  if (!user) return null;

  const component = roleComponents[user.role];

  if (!component) return null;

  // Si es función, la ejecuta con el user
  if (typeof component === "function") {
    return component(user);
  }

  // Si es JSX normal, lo retorna
  return component;
}